import React, { JSX } from 'react';
import { Box, IconButton, LinearProgress, Tooltip, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';
import RestoreIcon from '@mui/icons-material/Restore';
import SaveIcon from '@mui/icons-material/Save';
import { StatusBox, StatusIcon } from 'components/ui/StatusIcon';
import { AdminSectionProps } from './jobInfoTypes';

export function JobInfoAdminSection(props: AdminSectionProps): JSX.Element {
  const updatedChanged =
    (props.job.updatedAt && props.job.updatedAt.toISOString()) !==
    (props.activeJob.updatedAt && props.activeJob.updatedAt.toISOString());

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', p: 1 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          pl: 1,
          pr: 1,
          gap: 1,
          alignContent: 'center',
          height: '32px',
        }}
      >
        {updatedChanged && (
          <AdminButton title="Save Job" onClick={props.handleSave} icon={<SaveIcon />} />
        )}
        <AdminButton
          title="Delete Job"
          icon={<DeleteIcon />}
          onClick={() => {
            props.deleteJob(props.job.id);
            props.setDeleted(true);
          }}
        />
        <AdminButton title="Reset Job" onClick={props.handleReset} icon={<RestoreIcon />} />
        <AdminButton
          title="Reprocess Job"
          onClick={props.handleRefresh}
          icon={<ModelTrainingIcon />}
        />
      </Box>
      {props.adminStatus && (
        <Box sx={{ mt: 3 }}>
          <StatusBox>
            {props.adminStatusType && <StatusIcon type={props.adminStatusType} />}
            <Typography variant="body2" sx={{ ml: 1 }}>
              {props.adminStatus || 'Processing...'}
            </Typography>
          </StatusBox>
          {props.adminStatus && <LinearProgress sx={{ mt: 1 }} />}
        </Box>
      )}
    </Box>
  );
}

function AdminButton(props: {
  title: string;
  icon: JSX.Element;
  onClick: () => void;
}): JSX.Element {
  return (
    <Tooltip title={props.title}>
      <IconButton
        size="small"
        onClick={e => {
          e.stopPropagation();
          props.onClick();
        }}
      >
        {props.icon}
      </IconButton>
    </Tooltip>
  );
}
